import axios from "axios";
import localStorageService from "./localStorageService";
import config from "../../config";
import permissionsService from "./permissionsService";

class JwtAuthService {
  user = {
    userId: "1",
    role: "ADMIN",
    displayName: "Watson Joyce",
    email: "watsonjoyce@gmail.com",
    photoURL: "/assets/images/face-7.jpg",
    age: 25,
    token: "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh",
  };

  loginWithEmailAndPassword = async (email_user, password) => {
    const values = {
      email: email_user,
      password: password,
    };

    const ExisteUser = await config.post(`auth/singin`, { values });
    if (ExisteUser.data) {
      ExisteUser.data.token =
        "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh";
      ExisteUser.data.role = "ADMIN";
      //TODO: arreglar el servicio de logeo para devolver el usuario indicado.
      const response = ExisteUser.data;
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(response);
        }, 1000);
      }).then(async (data) => {
        this.setSession(data.token);
        this.setUser(data);
        await permissionsService.refresh();
        return data;
      });
    }
  };
  // loginWithToken = () => {
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       resolve(this.user);
  //     }, 100);
  //   }).then(data => {
  //     this.setSession(data.token);
  //     this.setUser(data);
  //     return data;
  //   });
  // };

  logout = () => {
    this.setSession(null);
    this.removeUser();
    permissionsService.clear();
  };

  setSession = (token) => {
    if (token) {
      localStorage.setItem("jwt_token", token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    } else {
      localStorage.removeItem("jwt_token");
      delete axios.defaults.headers.common["Authorization"];
    }
  };
  setUser = (user) => {
    localStorageService.setItem("auth_user", user);
  };
  removeUser = () => {
    localStorage.removeItem("auth_user");
  };
}

export default new JwtAuthService();
